export default __webpack_public_path__ + "static/LitigatorOfTheYear-7f95376b7364a1470b5ed9d7ece93728.png";